<wdpr-modal #errorModal class="error-modal" _has-buttons hide-close-icon>
  <div class="modal-center modal-body-wrapper" slot="body">
    <div class="modal-body" (tap)="toggle(null)">
      <span class="icon error"><i class="di di-alert"></i></span>
      <h2 class="center error-title">An error has occurred!</h2>
      @if (errorWrapper?.statusCode) {
        <p class="center error-status">
          <b>Status Code: {{errorWrapper?.statusCode}}</b>
        </p>
      } @else {
        <p class="center error-status">
          <b>Something went wrong!</b>
        </p>
      }
      <p class="error-message error-message">{{errorWrapper?.message}}</p>
    </div>
  </div>
</wdpr-modal>
